/**
 * Defines the string key values for user claim types.
 */
export enum UserClaimTypesEnum {

	Email = "Email",

	FirstName = "FirstName",

	LastName = "LastName"

}